module.exports = __webpack_public_path__ + "static/media/bryndwyr-2.2fc8d334.jpg";